import React from "react";
import Text from "@gc-npm/components.text";
import CustomLink from "@gc-npm/components.custom-link";
import Image from "@gc-npm/components.c-image";
import Button from "@gc-npm/components.button";
import Price from "@gc-npm/components.price";
import useDeviceKind from "@gc-npm/utils.common.get-device-kind-depends-on-viewport";
import style from "./style";

const textValue = (node) => (typeof node === "string" ? node : node?.text || "");
const StreamingSlide = ({
  image,
  title,
  seriesText,
  suscriptionText,
  aditionalPriceText,
  postPrice,
  price,
  button,
  cardLink,
  taggingInfo,
}) => {
  const device = useDeviceKind();

  const tTitle = textValue(title);
  const miniProps = {
    layout: "product",
    backgroundColor: "black",
    backgroundOpacity: "",
    cardShadow: "false",
    "CustomLink-1": {
      ...(cardLink || {}),
      taggingInfo: {
        ...taggingInfo,
        componentContent: suscriptionText?.text,
      },
      cyData: "StreamingPlatforms Card CustomLink",
    },
  };

  const sizes = "(min-width: 768px) 30vw, 90vw";

  return (
    <>
      <CustomLink
        {...miniProps["CustomLink-1"]}
        title={miniProps["CustomLink-1"]?.title || ""}
        taggingInfo={taggingInfo}
        className="card-clickable"
        cyData="Card CustomLink-1"
      >
        <div className="streaming-card">
          <div className="card-content">
            {image && image.src && (
              <div className={`card-content-image`} aria-hidden="true">
                <Image
                  {...image}
                  fill
                  objectFit={image?.objectFit || "cover"}
                  alt={image?.alt || tTitle || "Streaming card"}
                  sizes={sizes}
                />
              </div>
            )}
            <div className="card-content-text">
              {title && title.text && (
                <Text {...title} cyData="StreamingPlatforms Card Title" />
              )}
              {seriesText && seriesText.text && (
                <Text
                  {...seriesText}
                  cyData="StreamingPlatforms Card Serie Text"
                />
              )}
              <span className="separator" />
              <div className="price-container">
                {suscriptionText && suscriptionText.text && (
                  <Text
                    {...suscriptionText}
                    cyData="StreamingPlatforms Card Suscription Text"
                  />
                )}
                <div className="container-text-price">
                  {aditionalPriceText && aditionalPriceText.text && (
                    <Text
                      {...aditionalPriceText}
                      cyData="StreamingPlatforms Card Text Price"
                    />
                  )}
                  {price && price.price && (
                    <Price {...price} cyData="StreamingPlatforms Card Price" />
                  )}
                </div>
                {postPrice && postPrice.text && (
                  <Text
                    {...postPrice}
                    cyData="StreamingPlatforms Card Text PostPrice"
                  />
                )}
              </div>
            </div>
            {button && (
              <Button
                taggingInfo={{
                  ...taggingInfo,
                  componentContent: button?.label,
                }}
                cyData="StreamingPlatforms Card Button"
                {...button}
              />
            )}
          </div>
        </div>
      </CustomLink>

      <style jsx>{style}</style>
    </>
  );
};

export default StreamingSlide;

StreamingSlide.propTypes = {};
StreamingSlide.defaultProps = {};
